/**
 * Mino: Automatic Coupons & Cash Back
 *
 * Exposes two WAR groups — `assets/*` and `scripts/*` — to <all_urls> with no
 * `use_dynamic_url`, so every asset and content script is fetchable at a fixed URL from
 * any page.
 *
 * The brand logo is the cleanest signal: assets/images/logo@2x.png is vendor-named and,
 * being an image, loads through probeImage with no CORS grant. The picked script and
 * stylesheet are vendor-named too, so none of the chosen paths is a rotating build hash.
 *
 * Manifest verified against version 5.4.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fefnkplkicihcoenmljhbihhaaagjhpp';

export const mino: ExtensionDefinition = {
  id: ID,
  name: 'Mino: Automatic Coupons & Cash Back',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'assets/* and scripts/* exposed to every origin with no dynamic URL. The vendor-named ' +
    'logo image is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-logo-image',
      kind: 'web-accessible-resource',
      description:
        'Load assets/images/logo@2x.png via <img> — the Mino brand logo, exposed to ' +
        'every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/images/logo@2x.png'),
    },
    {
      id: 'war-realtime-offers-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/css/realtimeOffers.css — a vendor-named stylesheet, independent of ' +
        'the logo path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/css/realtimeOffers.css'),
    },
    {
      id: 'war-support-js',
      kind: 'web-accessible-resource',
      description: 'Fetch scripts/support.js — a vendor-named content script, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'scripts/support.js'),
    },
  ],
};
